module.exports = __webpack_public_path__ + "static/img/faceContain.bea2572.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/motor/components/personInfo/personFace/faceContain.png
// module id = THB+
// module chunks = 2